
















import Vue from "vue";
import PageHeading from "../components/PageHeading.vue";

export default Vue.extend({
  name: "OpenBankingSuccess",
  components: { PageHeading },
  methods: {
    close() {
      window.close();
    },
  },
});
